import { render, staticRenderFns } from "./companychecktemplatechecks.html?vue&type=template&id=5ed2de74&external"
import script from "./companychecktemplatechecks.vue?vue&type=script&lang=js"
export * from "./companychecktemplatechecks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports